import {CanDeactivate} from '@angular/router';
import {Injectable} from '@angular/core';
import {NgForm} from '@angular/forms';
import {UnsavedChangesService} from '@services/unsaved-changes.service';

type canDeactivateType = Promise<boolean> | boolean;

export interface CanComponentDeactivate {
  form: NgForm;
}

@Injectable()
export class UnsavedChangesGuard implements CanDeactivate<CanComponentDeactivate> {

  constructor(private unsavedChangesService: UnsavedChangesService) {
  }

  public canDeactivate(component: CanComponentDeactivate): canDeactivateType {
    return component.form ? this.isNavigationAllowed(component.form) : true;
  }

  private isNavigationAllowed(form: NgForm): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      if (!form.dirty || (form.submitted && form.valid) || this.unsavedChangesService.isRedirecting) {
        resolve(true);
      } else {
        this.unsavedChangesService.openDialog(resolve);
      }
    });
  }
}
